import { createReducer, on } from '@ngrx/store';
import { clearUser, setAccessToken, setIsLoggedIn, setSessionId, setToken, setUser, setUserName } from './user.actions';

export interface UserState {
  token: string | null;
  isLoggedIn: boolean;
  userName: string | null;
  sessionId: string | null;
  accessToken: string | null;
  detail: object | null;
  permissions: string[];
}

export const initialState: UserState = {
  token: null,
  isLoggedIn: false,
  detail: null,
  userName: null,
  sessionId: null,
  accessToken: null,
  permissions: [],
};
export const userReducer = createReducer(
  initialState,
  on(setToken, (state, { token }) => ({
    ...state,
    token,
  })),
  on(setIsLoggedIn, (state, { isLoggedIn }) => ({
    ...state,
    isLoggedIn,
  })),
  on(setUserName, (state, { userName }) => ({
    ...state,
    userName,
  })),
  on(setSessionId, (state, { sessionId }) => ({
    ...state,
    sessionId,
  })),
  on(setAccessToken, (state, { accessToken }) => ({
    ...state,
    accessToken,
  })),

  on(setUser, (state, action) => ({
    ...state,
    detail: action?.detail,
    permissions: action?.permissions,
  })),

  on(clearUser, () => ({ ...initialState }))
);
